import React from 'react';
import { FaMoneyBillWave, FaCheckCircle } from 'react-icons/fa';
import { SiMercadopago } from 'react-icons/si';
import { useTranslation } from '../../../shared/i18n';
import WhatsAppButton from './WhatsAppButton';
import * as S from '../Conecta2ProductPage.styles';

const PriceSection = ({ selectedPayment, onPaymentSelect, onClickWhatsApp, whatsAppMessage, paymentInfoMessage }) => {
  const t = useTranslation();
  
  return (
    <S.Section $background="linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%)">
      <S.Container>
        <S.SectionTitle>{t('conecta2Product.price.title')}</S.SectionTitle>
        <S.PriceOptionsSubtitle>{t('conecta2Product.price.subtitle')}</S.PriceOptionsSubtitle>
        
        <S.PriceGrid>
          <S.PriceOption 
            $selected={selectedPayment === 'mercadopago'}
            $mercadopago={true}
            onClick={() => onPaymentSelect('mercadopago')}
          >
            <S.PriceLabelContainer>
              <S.PaymentIcon $mercadopago={true}>
                <SiMercadopago />
              </S.PaymentIcon>
              <S.PriceLabel>{t('conecta2Product.price.mercadopago.label')}</S.PriceLabel>
            </S.PriceLabelContainer>
            <S.PriceContainer>
              <S.PriceAmount $mercadopago={true}>{t('conecta2Product.price.mercadopago.price')}</S.PriceAmount>
            </S.PriceContainer>
            {selectedPayment === 'mercadopago' && (
              <S.SelectedBadge>
                <FaCheckCircle />
                {t('conecta2Product.price.selected')}
              </S.SelectedBadge>
            )}
          </S.PriceOption>

          <S.PriceOption 
            $selected={selectedPayment === 'transferencia'}
            $recommended={true}
            onClick={() => onPaymentSelect('transferencia')}
          >
            <S.RecommendedBadge>{t('conecta2Product.price.transferencia.discount')}</S.RecommendedBadge>
            <S.PriceLabelContainer>
              <S.PaymentIcon>
                <FaMoneyBillWave />
              </S.PaymentIcon>
              <S.PriceLabel>{t('conecta2Product.price.transferencia.label')}</S.PriceLabel>
            </S.PriceLabelContainer>
            <S.PriceContainer>
              <S.PriceWithDiscount>
                <S.OriginalPrice>{t('conecta2Product.price.transferencia.originalPrice')}</S.OriginalPrice>
                <S.PriceAmount>{t('conecta2Product.price.transferencia.price')}</S.PriceAmount>
              </S.PriceWithDiscount>
            </S.PriceContainer>
            {selectedPayment === 'transferencia' && (
              <S.SelectedBadge>
                <FaCheckCircle />
                {t('conecta2Product.price.selected')}
              </S.SelectedBadge>
            )}
          </S.PriceOption>
        </S.PriceGrid>

        <WhatsAppButton 
          onClick={onClickWhatsApp}
          message={whatsAppMessage}
        />

        <S.SecondaryLink href={paymentInfoMessage} target="_blank" rel="noopener noreferrer">
          {t('conecta2Product.price.paymentInfoLink')}
        </S.SecondaryLink>
      </S.Container>
    </S.Section>
  );
};

export default PriceSection;
